import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { InviteModel } from "./state/models/InviteModel";

@Component({
  templateUrl: "inviteDialog.component.html",
})
export class InviteDialogComponent {
  public constructor(
    public dialogRef: MatDialogRef<InviteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InviteModel
  ) {}

  public onNoClick(): void {
    this.dialogRef.close();
  }
}
